webpackJsonp([39359645935544],{

/***/ 2034:
/***/ (function(module, exports) {

	module.exports = {"pathContext":{"name":"StripeInvoiceSettings","kind":"OBJECT","type":"OBJECT","fields":[{"args":[],"deprecationReason":null,"description":null,"isDeprecated":false,"name":"defaultPaymentMethod","type":{"kind":"OBJECT","name":"StripePaymentMethod","ofType":null}}],"description":null,"enumValues":null,"possibleTypes":null}}

/***/ })

});


// WEBPACK FOOTER //
// path---object-stripe-invoice-settings-7a7229acb1462f1c4ca1.js